(function () {
  function initHerCarousel(root) {
    var track = root.querySelector('[data-her-carousel-track]');
    var prevBtn = root.querySelector('[data-her-carousel-prev]');
    var nextBtn = root.querySelector('[data-her-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function getScrollStep() {
      var card = track.querySelector('.her-product-card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: direction * getScrollStep(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollByStep(-1);
    });

    nextBtn.addEventListener('click', function () {
      scrollByStep(1);
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-her-carousel]').forEach(initHerCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
